
import { AbstractDisplayComponent } from "../../core/displays/AbstractDisplayComponent";
import { DisplayComponent } from "../../core/displays/DisplayComponent";
import { Manager } from "../../core/Manager";
import { reelSpinEmitter } from "../../core/reels/ReelInit";
import { spinData } from "../../server/getServerResposesFun";
import { wait } from "../../utils";
import { SequentialTask } from "../../utils/SequentialTask";
import { CharacterComponent } from "../character/CharacterComponent";
import { GunShootComponent } from "../gunShoot/GunShootComponent";
import { HighlightFrames } from "../highlight/HighlightFrames";
import { HighlightFramesComponent } from "../highlight/HighlightFramesComponent";
import { ReelCellComponent } from "../reelCellContainer/ReelCellComponent";
import { ReelCellContainer } from "../reelCellContainer/ReelCellContainer";
import { WinMeterComponent } from "../winmeters/WinMeterComponent";

export class WinSeqComponent extends AbstractDisplayComponent {
    protected currentRespinIndex: number = 0;

    public startWinSeqFeature(currentRespinIndex: number, callback?: () => void): Promise<any> {
        this.currentRespinIndex = currentRespinIndex;
        let seq = new SequentialTask([
            () => this.distributeMulti(currentRespinIndex),
            () => this.highlightPlaces(currentRespinIndex),
            () => this.highlightMultiPlaces(currentRespinIndex),
            //() => wait(500),
            //() => this.sortTheGodsOrder(currentRespinIndex),
            //() => this.sortTheOrder(),
            //() => this.callFeatureOneByone(),
            // () => this.collectFeature(currentRespinIndex),
            // () => this.adderFeature(currentRespinIndex),
            // () => this.doubleFeature(currentRespinIndex),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    public endWinSeqFeature(currentRespinIndex: number, callback?: () => void): Promise<any> {
        this.currentRespinIndex = currentRespinIndex;
        let seq = new SequentialTask([
            () => this.removeMultis(currentRespinIndex),
            () => this.hideHighlightPlaces(currentRespinIndex),
            //() => wait(500),
            //() => this.sortTheGodsOrder(currentRespinIndex),
            //() => this.sortTheOrder(),
            //() => this.callFeatureOneByone(),
            // () => this.collectFeature(currentRespinIndex),
            // () => this.adderFeature(currentRespinIndex),
            // () => this.doubleFeature(currentRespinIndex),
            () => {
                callback?.();
                return Promise.resolve();
            }
        ]);
        return seq.execute();
    }

    private getInitFinalMultiplier(respinIndex: number, reelNum: number, posNum: number): number {
        const finalMultis = spinData.respins[respinIndex].initMultiplers;
        return finalMultis.find(item => item.reelNum === reelNum && item.posNum === posNum)?.multi;
        // for (let i = 0; i < finalMultis.length; i++) {
        //     if (finalMultis[i].reelNumfinalMultis[i].multi != 0) {
    }

    private async distributeMulti(respinIndex: number, callback?: () => void): Promise<any> {
        const newMultis = spinData.respins[respinIndex].newMultiplers;
        if (!newMultis || newMultis.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        reelSpinEmitter.emit('shakeEffect');
        //checking portrait or landscape to decide which shoot animation to play
        Manager.screenwidth < Manager.screenHeight ? DisplayComponent.get(CharacterComponent).playShoot(2) : DisplayComponent.get(CharacterComponent).playShoot(2);
        await wait(350);
        const promises: Promise<void>[] = [];
        for (let i = 0; i < newMultis.length; i++) {
            if (newMultis[i].multi != 0) {
                const promise = new Promise<void>(async (resolve) => {
                    //async () => {
                    const finalMultis = this.getInitFinalMultiplier(respinIndex, newMultis[i].reelNum, newMultis[i].posNum);
                    console.log("newMultis[i].reelNum, newMultis[i].posNum, newMultis[i].multi, finalMultis[i].multi ", newMultis[i].reelNum, newMultis[i].posNum, newMultis[i].multi, finalMultis);
                    (DisplayComponent.get(ReelCellComponent).getInstance() as ReelCellContainer).highlight(newMultis[i].reelNum, newMultis[i].posNum);
                    DisplayComponent.get(WinMeterComponent).getInstance().addMultiplier(newMultis[i].reelNum, newMultis[i].posNum, newMultis[i].multi, finalMultis, resolve);
                    //await wait(50);
                    //}
                });
                promises.push(promise);
                //await wait(50);
            }
        }
        if (promises.length > 0)
            await Promise.all(promises);
        callback?.();
        return Promise.resolve();
    }

    private async highlightMultiPlaces(respinIndex: number, callback?: () => void): Promise<any> {
        const highlightMultis = spinData.respins[respinIndex].highlightedMultipliers;
        const sumHighlightMultis = spinData.respins[respinIndex].sumHighLightedMulti;
        //const highlights = spinData.respins[respinIndex].highlights;
        if (!highlightMultis || highlightMultis.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        console.log(highlightMultis);
        const promises: Promise<void>[] = [];
        for (let i = 0; i < highlightMultis.length; i++) {
            //async () => {
            if (highlightMultis[i].multi != 0) {
                const promise = new Promise<void>(async (resolve) => {
                    (DisplayComponent.get(ReelCellComponent).getInstance() as ReelCellContainer).highlight(highlightMultis[i].reelNum, highlightMultis[i].posNum, true);
                    DisplayComponent.get(WinMeterComponent).getInstance().addMultiplier(highlightMultis[i].reelNum, highlightMultis[i].posNum, highlightMultis[i].multi, sumHighlightMultis[i].multi, resolve);
                    //await wait(50);
                });
                promises.push(promise);
                //await wait(50);
            }
        }
        if (promises.length > 0)
            await Promise.all(promises);
        callback?.();
        return Promise.resolve();
    }

    private async highlightPlaces(respinIndex: number, callback?: () => void): Promise<any> {
        const highlightMultis = spinData.respins[respinIndex].highlights;
        if (!highlightMultis || highlightMultis.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        console.log(spinData.respins[respinIndex].feature);
        //console.log(spinData.respins[respinIndex].highlights);
        console.log(highlightMultis);
        for (let i = 0; i < highlightMultis.length; i++) {
            //async () => {
            //if (highlightMultis[i].multi != 0) {
            //(DisplayComponent.get(ReelCellComponent).getInstance() as ReelCellContainer).highlight(highlightMultis[i][0], highlightMultis[i][1]);
            (DisplayComponent.get(HighlightFramesComponent).getInstance() as HighlightFrames).highlight(highlightMultis[i][0], highlightMultis[i][1]);
            await wait(50);
            //}
            //}
        }
        await wait(500);
        DisplayComponent.get(GunShootComponent).showHand();
        await wait(450);
        reelSpinEmitter.emit('shakeEffect');
        callback?.();
        return Promise.resolve();
    }

    private async hideHighlightPlaces(respinIndex: number, callback?: () => void): Promise<any> {
        const highlightMultis = spinData.respins[respinIndex].sumHighLightedMulti;
        if (!highlightMultis || highlightMultis.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        console.log(highlightMultis);
        for (let i = 0; i < highlightMultis.length; i++) {
            //async () => {
            if (highlightMultis[i].multi != 0) {
                (DisplayComponent.get(HighlightFramesComponent).getInstance() as HighlightFrames).hide(highlightMultis[i].reelNum, highlightMultis[i].posNum);
                //await wait(25);
            }
            //}
        }
        callback?.();
        return Promise.resolve();
    }

    private async removeMultis(respinIndex: number, callback?: () => void): Promise<any> {
        const newMultis = spinData.respins[respinIndex].removeMulti;
        if (!newMultis || newMultis.length === 0) {
            callback?.();
            return Promise.resolve();
        }
        for (let i = 0; i < newMultis.length; i++) {
            DisplayComponent.get(WinMeterComponent).getInstance().vanishMultis(newMultis[i].reelNum, newMultis[i].posNum);
            DisplayComponent.get(ReelCellComponent).getInstance().hide(newMultis[i].reelNum, newMultis[i].posNum);
        }
        callback?.();
        return Promise.resolve();
    }

    public async removeMultiHighlight(reelNum: number, posNum: number, callback?: () => void): Promise<any> {
        DisplayComponent.get(ReelCellComponent).getInstance().beforeHide(reelNum, posNum);
        await DisplayComponent.get(WinMeterComponent).getInstance().beforeVanishMultis(reelNum, posNum);
        DisplayComponent.get(WinMeterComponent).getInstance().vanishMultis(reelNum, posNum);
        DisplayComponent.get(ReelCellComponent).getInstance().hide(reelNum, posNum);
        (DisplayComponent.get(HighlightFramesComponent).getInstance() as HighlightFrames).hide(reelNum, posNum);
        callback?.();
        return Promise.resolve();
    }

    public async removeAllMultis(callback?: () => void): Promise<any> {
        await DisplayComponent.get(WinMeterComponent).getInstance().vanishAllMultis();
        await DisplayComponent.get(ReelCellComponent).getInstance().hideAll();
        await (DisplayComponent.get(HighlightFramesComponent).getInstance() as HighlightFrames).hideAllFrameFS();
        callback?.();
        return Promise.resolve();
    }

    public getInstance(): any {
        return null;
    }
}